<template>
  <section class="how-it-works-section">
    <v-landing-container>
      <h2 class="how-it-works__title">
        {{ $t('v.home.titleCostReduction') }}
      </h2>
      <div class="how-it-works__wrapper">
        <ul class="how-it-works__list">
          <li class="how-it-works__item" v-html="$t('v.home.descriptionDisablingAdPlatforms')"></li>
          <li class="how-it-works__item" v-html="$t('v.home.descriptionBanimSites')"></li>
          <li class="how-it-works__item" v-html="$t('v.home.descriptionExclude')"></li>
          <li class="how-it-works__item" v-html="$t('v.home.descriptionLimit')"></li>
        </ul>
        <div class="how-it-works__img">
          <img
            src="/screenshot_of_the_screen.png"
            srcset="/screenshot_of_the_screen@2x.png 2x"
            class="how-it-works__img-item" alt=""
          >
        </div>
      </div>
    </v-landing-container>
  </section>
</template>

<script>
import VLandingContainer from '@/components/Landing/VLandingContainer.vue'

export default {
  name: 'HomeAdvantages',
  components: { VLandingContainer }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/style/scss/vars";
@import "../../../assets/style/scss/extends";

.how-it-works-section {
  padding-top: 120px;
  padding-bottom: 143px;
}

.how-it-works__title {
  font-family: $font-gilroy;
  letter-spacing: -0.04em;
  font-weight: map-get($font-weight, "extra-bold");
  font-size: 40px;
  color: #333333;
  margin-bottom: 50px;
}

.how-it-works__wrapper {
  display: flex;
  justify-content: space-between;
}

.how-it-works__list {
  width: 44%;
  margin-right: 45px;
  list-style: none;
}

.how-it-works__item {
  font-size: 17px;
  font-family: $font-cabin;
  font-weight: map-get($font-weight, "regular");
  margin-bottom: 38px;
  line-height: 1.39;
}

.how-it-works__img {
  flex: 1;
}

.how-it-works__img-item {
  max-width: 100%;
}
</style>
